import { Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { WithChildren } from '../../_metronic/helpers'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import CurrentLog from '../pages/dashboard/CurrentLog'
import AccountPage from '../modules/accounts/AccountPage'
const GameRoute = lazy(() => import('../users-section/game/route'))
const CompanyPage = lazy(() => import('../master/company/UsersPage'))
const LocationPage = lazy(() => import('../master/geoLocation/GeoPage'))
const BankPage = lazy(() => import('../master/bank/BankPage'))
const ComapanyManage = lazy(() => import('../company-module/company-manage'))
const Communication = lazy(() => import('../communication/comm'))
const ProductManage = lazy(() => import('../master/products/product'))
const Configuration = lazy(() => import('../configuration/config'))
const TelecallingManage = lazy(() => import('../master/telecalling/telecalling'))
const Rolespage = lazy(() => import('../master/roles/ModulePage'))
const FaqPage = lazy(() => import('../faq/FaqPage'))
const ReportManage = lazy(() => import('../master/reports/reports'))
const ProjectPage = lazy(() => import('../master/project/ProjectPage'))
const KycModule = lazy(() => import('../users-section/kyc/dashboard/kycModule'))
const NotesManage = lazy(() => import('../company-module/userNote/note-route'))
const RedemptionsPage = lazy(() => import('../company-module/redemptionList/RedemptionPage'))
const RedemptionOtherPage = lazy(() => import('../master/courier/vendorPage'))
const DistributorAdminPage = lazy(() => import('../distributorAdmin/DistributorAdminRoute'))
const AdminComplaintPages = lazy(() => import('../master/telecalling/complaints/admin/adminComplaintPage'))
const KYCAdminPage = lazy(() => import('../master/kyc/kycAdmin/kycFrontPage'))
const MediaPage = lazy(() => import('../media/MediaPage'))
const FullfillmentManage = lazy(() => import('../master/fullfillment/fullfillment'))
const CourierPage = lazy(() => import('../master/courier/CourierPage'))
const KYCPage = lazy(() => import('../master/kyc/KycPage'))
const BadgePage = lazy(() => import('../master/badge/badgePage'))
const BeatPlanPage = lazy(() => import('../master/beatplan/beatPlanPage'))
const ProjectOfferPage = lazy(() => import('../company-module/projectOffer/projectOffer'))
const ProjectRolesPage = lazy(() => import('../company-module/roles/ProjectModulePage'))
const TeleCallingRoutes = lazy(() => import('../master/teleCallings/teleCallingsRoutes'))
const RoleReportAssignmentPage = lazy(() => import('../master/roleReportAssignment/index'))
const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--kt-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}
export const AdminRoute = [
    {
        path: 'auth/*',
        module: "auth",
        comp: <Navigate to='/dashboard' />
    },
    {
        path: '/admin/account/*',
        module: "auth",
        comp: <SuspensedView><AccountPage /></SuspensedView>
    },
    {
        path: 'dashboard',
        module: "dashboard",
        comp: <SuspensedView><DashboardWrapper /></SuspensedView>
    },
    {
        path: 'current-log',
        module: "dashboard",
        comp: <SuspensedView><CurrentLog /></SuspensedView>
    },

    {
        path: 'admin/games/*',
        module: "dashboard",
        comp: <SuspensedView><GameRoute /></SuspensedView>
    },

    {
        path: 'admin/location/*', module: "company-management", comp: <SuspensedView><LocationPage /></SuspensedView>

    },
    {
        path: 'admin/bank/*', module: "bank", comp: <SuspensedView>
            <BankPage />
        </SuspensedView>
    },
    {
        path: 'admin/fullfillment/*',
        module: "fullfillment",
        comp: <SuspensedView><FullfillmentManage /></SuspensedView>
    },

    {
        path: 'admin/company/*', module: "company-management", comp: <SuspensedView>
            <CompanyPage />
        </SuspensedView>
    },
    {
        path: 'admin/project/*', module: ["projects", "company"], comp: <SuspensedView>
            <ProjectPage />
        </SuspensedView>
    },
    {
        path: 'admin/courier/*', module: "courier", comp: <SuspensedView>
            <CourierPage />
        </SuspensedView>
    },
    {
        path: 'admin/communication/*', module: "communication", comp: <SuspensedView>
            <Communication />
        </SuspensedView>
    },

    {
        path: 'admin/kyc/*',
        module: "KYC",
        comp: <SuspensedView>
            <KYCPage />
        </SuspensedView>
    },
    {
        path: 'user/kyc/*',
        module: "KYC",
        comp: <SuspensedView>
            <KycModule />
        </SuspensedView>
    },

    {
        path: 'admin/product/*',
        module: "product",
        comp: <SuspensedView><ProductManage /></SuspensedView>
    },
    {
        path: 'admin/faq/*',
        module: "FAQs",
        comp: <SuspensedView><FaqPage /></SuspensedView>
    },
    {
        path: 'admin/media/*',
        module: "Media",
        comp: <SuspensedView><MediaPage /></SuspensedView>
    },
    {
        path: 'apps/company-management/*',
        module: "company-management",
        comp: <SuspensedView><ComapanyManage /></SuspensedView>
    },
    {
        path: 'apps/offer-management/*',
        module: "ProjectOffer",
        comp: <SuspensedView><ProjectOfferPage /></SuspensedView>
    },
    {
        path: 'apps/company-user/*',
        module: "company-management",
        comp: <SuspensedView><NotesManage /></SuspensedView>
    },

    {
        path: 'apps/company-management/redemption/*',
        module: "redemption-catalogue",
        comp: <SuspensedView>
            <RedemptionsPage />
        </SuspensedView>
    },
    {
        path: 'admin/redeOtherPage/*',
        module: "courier",
        comp: <SuspensedView>
            <RedemptionOtherPage />
        </SuspensedView>
    },


    {
        path: 'admin/configuration/*',
        module: "configuration",
        comp: <SuspensedView><Configuration /></SuspensedView>
    },

    {
        path: 'admin/telecalling/*',
        module: "telecalling",
        comp: <SuspensedView><TelecallingManage /></SuspensedView>
    },
    {
        path: 'admin/roles/*',
        module: "roles",
        comp: <Rolespage />
    },
    {
        path: 'admin/reports/*',
        module: "reports",
        comp: <SuspensedView><ReportManage /></SuspensedView>
    },
    {
        path: 'admin/distributor/*',
        module: "order",
        comp: <SuspensedView>
            <DistributorAdminPage />
        </SuspensedView>
    },
    {
        path: 'admin/complaint/*',
        module: "order",
        comp: <SuspensedView>
            <AdminComplaintPages />
        </SuspensedView>
    },
    {
        path: 'kyc/*',
        module: "order",
        comp: <SuspensedView>
            <KYCAdminPage />
        </SuspensedView>
    },
    {
        path: 'admin/badge/*', module: "company-management", comp: <SuspensedView>
            <BadgePage />
        </SuspensedView>
    },
    {
        path: 'admin/company-management/*', module: "company-management", comp: <SuspensedView>
            <BeatPlanPage />
        </SuspensedView>
    },
    {
        path: 'admin/project-roles/*',
        module: "roles",
        comp: <SuspensedView><ProjectRolesPage /></SuspensedView>
    },
    {
        path: 'admin/tele-calling/*',
        module: "telecalling",
        comp: <SuspensedView><TeleCallingRoutes /></SuspensedView>
    },
    {
        path: 'admin/role-report-assignment/*',
        module: "roles",
        comp: <SuspensedView><RoleReportAssignmentPage /></SuspensedView>
    },
]
